import { Link, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "@features/auth/AuthContext";

export function Coquille() {
  const { utilisateur, deconnexion } = useAuth();
  return (
    <>
      <header className="top">
        <Link to="/recherche" className="brand">scraping<b>-for-</b>sales</Link>
        <nav className="nav">
          <NavLink to="/recherche">Recherche</NavLink>
          <NavLink to="/prospection">Prospection</NavLink>
          {utilisateur?.role === "admin" && <NavLink to="/admin">Admin</NavLink>}
        </nav>
        <div className="droite">
          <span className="mono">{utilisateur?.nom}</span>
          <button className="btn ghost sm clair" onClick={deconnexion}>Se déconnecter</button>
        </div>
      </header>
      <Outlet />
    </>
  );
}
